/**
 * api 统一封装方法
 * @description api集合为元数据，可直接在页面使用 this.$api[module][api]某某方法
 * @example api.login.logout(queryOrBodyData, opt)
 *
 * @param {Object} queryOrBodyData? 查询参数 或者 荷载数据
 * @param {Boolean} opt axios配置
 *
 * @return {Object<{ data }>}
 */

import { message as Message } from 'ant-design-vue';
import axios, { domain } from '@/plugins/axios';
import utils from '@/plugins/utils'
import Md5 from 'js-md5';
import qs from 'qs';

import CommonApi from './modules/common.api';
import LoginApi from './modules/login.api';
import ShowdataApi from './modules/showdata.api';//展示数据设置
import ScreenvgaApi from './modules/screenvga.api';//屏幕分辨率设置
import AccountApi from './modules/account.api';//大屏帐号管理
import NewshowdataApi from './modules/Newshowdata.api';//新桐庐数据大屏设置

const _domain = process.env.VUE_APP_API_URL;
// 合并所有模块api并导出到外部， 可直接在页面使用 this.$api.某某方法
const APIS = {
    common:CommonApi,
    login: LoginApi,
    showdata: ShowdataApi,
    screenvga: ScreenvgaApi,
    account:AccountApi,
    newshowdata:NewshowdataApi,
}
/**
 * 请求前 中间件
 * @param {ApiMeta} apiMeta API元数据
 * @param {Query/Body} data 请求数据
 */
function foreRequestMiddleWare (apiMeta, data) {
    const { schema, name } = apiMeta;

};

/**
 * 请求失败后 中间件
 * @param {ApiMeta} apiMeta API元数据
 * @param {Error} error 请求错误对象
 * @param {Function} next 下一步
 */
function fallbackMiddleWare (apiMeta, error, next) {
    const { name, method, url } = apiMeta;

    console.error(`[${method}][${domain}${url}]: ${name} 失败，${error.message}`);
    // Message.error(`${name} 失败，${error.message}`);
    next(error);
};

// 将单个模块的 meta 转换为 请求
function Proxyable(target) {
    const target_ = {};
    for (const key in target) {
        if (target.hasOwnProperty(key)) {
            target_[key] = ProxyApi(target, key);
        }
    }
    return target_;
}

// 将 ApiMeta 映射为 http 请求
function ProxyApi(target, key) {
    if (!target[key]) throw new ReferenceError('API ' + key + ' not exist');

    const {
        method,
        url,
        name
    } = target[key];
    if (method.toUpperCase() === 'GET') { //toUpperCase转换成大写
        return (query = {}, opt) => new Promise((resolve, reject) => {
            query = qs.parse(query);  
           //  opt.params = md5data;
            foreRequestMiddleWare(target[key], query);
            axios.get(url, Object.assign({}, {
                params: query,

            }, opt))
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    }else if (method.toUpperCase() === 'DELETE') {
        return (body = {}, opt) => new Promise((resolve, reject) => {
            let qsBody = qs.stringify(body);
            foreRequestMiddleWare(target[key], body);
            axios.delete(url, {data:qsBody},qsBody,{

            }, opt)
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    } else if (method.toUpperCase() === 'POST') {
        return (body = {}, opt) => new Promise((resolve, reject) => {
            let qsBody = qs.stringify(body);
            foreRequestMiddleWare(target[key], body);
            axios.post(url, qsBody,{

            }, opt)
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    } else if (method.toUpperCase() === 'PUT') {
        return (body = {}, opt) => new Promise((resolve, reject) => {
            
            let qsBody = qs.stringify(body);
           
            foreRequestMiddleWare(target[key], body);

            axios.put(url, qsBody,{
                
            }, opt)
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    } else if(method.toUpperCase() === 'UPLOAD'){
        return (body = {}, opt) => new Promise((resolve, reject) => {
            body = body;

            foreRequestMiddleWare(target[key], body);

            axios.post(url, body,{
                headers: {
                    "appid":body.appid,
                    "timestamp":body.timestamp,
                    "nonce":body.nonce,
                    "signature":body.signature
                }
            }, opt)
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    }else {
        throw new Error('【API】API源数据信息错误，不支持的方法：' + method);
    }
}

const API_ = {};
Object.keys(APIS).forEach(apiName => {
    API_[apiName] = Proxyable(APIS[apiName]);
});

export default API_;



// let config = {
//     baseURL: _domain,
//     timeout: 60 * 1000, // Timeout
//     withCredentials: true, // Check cross-site Access-Control
//     headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//         'appid' : 'sortingcenter1.0',
//         'nonce' : 'test_sortingcenter'
//     }
// };

// const apiMod = new ApiModule({
//     baseConfig: config,
//     module: true,
//     apiMetas: {
//         common:CommonApi,
//         user: userApi,
//         login: LoginApi,
//         order:OrderApi,
//         account:AccountApi,
//         sparkonto:SparkontoApi
//     }
// });

// apiMod.registerForeRequestMiddleWare(middleWares.foreRequestMiddleWare);
// apiMod.registerFallbackMiddleWare(middleWares.fallbackMiddleWare);

// const apiInstance = apiMod.getInstance();
// const axios = apiMod.getAxios();
// Vue.prototype.$api = apiInstance;

// export default axios;
